import { PlusOutlined, LoadingOutlined } from "@ant-design/icons"
import { Modal, Upload, message } from "antd"
import type { RcFile, UploadProps } from "antd/es/upload"
import type { UploadFile } from "antd/es/upload/interface"
import axios from "axios"
import React, { useEffect, useState } from "react"

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })

interface UploadProofOfDeliveriesProps {
  uploadURL: string
  uploadPodCallback?: () => Promise<void>
  data: Record<string, string>
  skipFilename?: boolean
  filesLimit?: number
  accept?: string
}
const UploadProofOfDeliveries: React.FC<UploadProofOfDeliveriesProps> = ({
  uploadURL,
  data,
  uploadPodCallback,
  skipFilename,
  filesLimit,
  accept,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState("")
  const [previewTitle, setPreviewTitle] = useState("")
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState<UploadFile[]>([])

  useEffect(() => {
    return () => {
      setFileList([])
      setPreviewImage("")
      setPreviewTitle("")
      setPreviewOpen(false)
    }
  }, [])

  const handleCancel = () => setPreviewOpen(false)
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile)
    }

    setPreviewImage(file.url || (file.preview as string))
    setPreviewOpen(true)
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1))
  }

  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) =>
    setFileList(newFileList)

  const uploadButton = <div>{loading ? <LoadingOutlined /> : <PlusOutlined />}</div>

  return (
    <>
      <Upload
        showUploadList={!!!uploadPodCallback}
        accept={accept}
        className="upload-pod-form flex"
        listType="picture-card"
        style={{ width: 40, height: 40 }}
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        customRequest={({ file, onError, onSuccess, onProgress }) => {
          const rcFile = file as RcFile
          const fileBlob = new Blob([file])
          const formData = new FormData()

          Object.keys(data).forEach((key) => {
            if (key == "key" && !skipFilename) {
              const fileName = Date.now().toString()
              const extensionHeader = data["Content-Type"] ?? "image/jpeg"
              const extension = extensionHeader.split("/")[1]
              formData.append(key, `${data[key]}/${fileName}.${extension}`)
            } else {
              formData.append(key, data[key] || "")
            }
          })
          formData.append("file", fileBlob, rcFile.name)
          var options = {
            onUploadProgress: (event: ProgressEvent) => {
              const { loaded, total } = event
              onProgress?.({
                percent: Math.round((loaded / total) * 100),
              })
            },
            headers: {
              "Content-Type": "multiple/form-data",
              Authorization: "",
            },
          }
          setLoading(true)
          const axiosWithoutDefaultHeaders = axios.create()
          axiosWithoutDefaultHeaders
            .post(uploadURL, formData, options)
            .then(async (result) => {
              onSuccess?.(result)
              if (uploadPodCallback) {
                await uploadPodCallback()
              }
              if (filesLimit) {
                setFileList([])
              }
              if (!skipFilename) {
                message.success("Successfully Upload!")
              }
            })
            .catch((error) => {
              onError?.(error)
            })
            .finally(() => {
              setLoading(false)
            })
        }}
      >
        {fileList.length >= (filesLimit || 3) ? null : uploadButton}
      </Upload>
      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  )
}

export default UploadProofOfDeliveries
